define('view/controller/booking/service/ServiceStepView',['require','lib/view/CompositeView','view/controller/booking/service/ServiceItemView','view/controller/booking/service/ServiceEmptyView'],function (require) {
	
	var CompositeView = require('lib/view/CompositeView');
	var ServiceItemView = require('view/controller/booking/service/ServiceItemView');
	var ServiceEmptyView = require('view/controller/booking/service/ServiceEmptyView');
	
	/**
	 * Services composite view (services container)
	 * 
	 * @class ServiceStepView
	 */
	return CompositeView.extend({
	
	    template: '#service_step',
	    childView: ServiceItemView,
	    childViewContainer: '#sb_service_step_container',
        
        emptyView: ServiceEmptyView,
        isEmpty: function (collection) {
            return collection._once_synced ? collection.isEmpty() : false;
        },

		_pageId: 'booking_service',

		serializeData: function () {
	    	return _.extend(CompositeView.prototype.serializeData.apply(this), {
	    		splitted: this.collection.hasClassesAndServices()
			});
		}
	    
	});
	
});
